import { CommonModule } from '@angular/common';
import { Component, computed, inject, input, output } from '@angular/core';
import { ProductKeys } from '@config/keys/product.keys';
import { ColorFieldTypesValues } from '@config/values/color-field-types.values';
import { IContentBuilderFieldColor } from '@core/models/content-builder-fields.model';
import { DoodProductModel } from '@core/models/product.model';
import { KioskProductCardV2AtomComponent } from '../kiosk-product-card-v2-atom/kiosk-product-card-v2-atom.component';
import { KioskProductCardV3AtomComponent } from '../kiosk-product-card-v3-atom/kiosk-product-card-v3-atom.component';
import { KioskProductCardV4AtomComponent } from '../kiosk-product-card-v4-atom/kiosk-product-card-v4-atom.component';
import { KioskProductCardV5AtomComponent } from '../kiosk-product-card-v5-atom/kiosk-product-card-v5-atom.component';
import { KioskProductCardV6AtomComponent } from '../kiosk-product-card-v6-atom/kiosk-product-card-v6-atom.component';
import { KioskGlobalSettingsService } from '@store/kiosk-global-settings/kiosk-global-settings.service';
import { KioskProductCardInputs } from './kiosk-product-cart';
import { KioskProductCardV1AtomComponent } from '../kiosk-product-card-v1-atom/kiosk-product-card-v1-atom.component';

@Component({
  selector: 'app-kiosk-product-card-factory',
  imports: [
    CommonModule,
    KioskProductCardV1AtomComponent,
    KioskProductCardV2AtomComponent,
    KioskProductCardV3AtomComponent,
    KioskProductCardV4AtomComponent,
    KioskProductCardV5AtomComponent,
    KioskProductCardV6AtomComponent,
  ],
  styles: [
    `
      :host {
        display: contents;
      }
    `,
  ],
  template: `
    @if (productCardChoice() === 1) {
      <app-kiosk-product-card-atom
        [product]="product()"
        [quantity]="quantity()"
        (addProduct)="addProduct.emit()"
        (showProduct)="showProduct.emit()"
        [textColor]="textColor()"
        [cardColor]="cardColor()"
        [isProductAvailable]="effectiveIsProductAvailable()"
        [buttonBackgroundColor]="buttonBackgroundColor()"
        [unavailableButtonBackground]="unavailableButtonBackground()"
        [unavailableButtonText]="unavailableButtonText()"
        [buttonTextColor]="buttonTextColor()"
        [priceColor]="priceColor()"
        [borderColor]="borderColor()"
        [class]="productCardType()"
        [isShowProductIcon]="isShowProductIcon()"
      />
    } @else if (productCardChoice() === 2) {
      <app-kiosk-product-card-v2-atom
        [product]="product()"
        [quantity]="quantity()"
        (addProduct)="addProduct.emit()"
        (showProduct)="showProduct.emit()"
        [textColor]="textColor()"
        [cardColor]="cardColor()"
        [isProductAvailable]="effectiveIsProductAvailable()"
        [buttonBackgroundColor]="buttonBackgroundColor()"
        [unavailableButtonBackground]="unavailableButtonBackground()"
        [unavailableButtonText]="unavailableButtonText()"
        [buttonTextColor]="buttonTextColor()"
        [priceColor]="priceColor()"
        [class]="productCardType()"
        [isShowProductIcon]="isShowProductIcon()"
      />
    } @else if (productCardChoice() === 3) {
      <app-kiosk-product-card-v3-atom
        [product]="product()"
        [quantity]="quantity()"
        (addProduct)="addProduct.emit()"
        (showProduct)="showProduct.emit()"
        [textColor]="textColor()"
        [cardColor]="cardColor()"
        [isProductAvailable]="effectiveIsProductAvailable()"
        [buttonBackgroundColor]="buttonBackgroundColor()"
        [unavailableButtonBackground]="unavailableButtonBackground()"
        [unavailableButtonText]="unavailableButtonText()"
        [buttonTextColor]="buttonTextColor()"
        [priceColor]="priceColor()"
        [class]="productCardType()"
        [isShowProductIcon]="isShowProductIcon()"
      />
    } @else if (productCardChoice() === 4) {
      <app-kiosk-product-card-v4-atom
        [product]="product()"
        [quantity]="quantity()"
        (addProduct)="addProduct.emit()"
        (showProduct)="showProduct.emit()"
        [textColor]="textColor()"
        [cardColor]="cardColor()"
        [isProductAvailable]="effectiveIsProductAvailable()"
        [buttonBackgroundColor]="buttonBackgroundColor()"
        [unavailableButtonBackground]="unavailableButtonBackground()"
        [unavailableButtonText]="unavailableButtonText()"
        [buttonTextColor]="buttonTextColor()"
        [priceColor]="priceColor()"
        [class]="productCardType()"
        [isShowProductIcon]="isShowProductIcon()"
      />
    } @else if (productCardChoice() === 5) {
      <app-kiosk-product-card-v5-atom
        [product]="product()"
        [quantity]="quantity()"
        (addProduct)="addProduct.emit()"
        (showProduct)="showProduct.emit()"
        [textColor]="textColor()"
        [cardColor]="cardColor()"
        [isProductAvailable]="effectiveIsProductAvailable()"
        [buttonBackgroundColor]="buttonBackgroundColor()"
        [unavailableButtonBackground]="unavailableButtonBackground()"
        [unavailableButtonText]="unavailableButtonText()"
        [buttonTextColor]="buttonTextColor()"
        [priceColor]="priceColor()"
        [class]="productCardType()"
        [isShowProductIcon]="isShowProductIcon()"
      />
    } @else if (productCardChoice() === 6) {
      <app-kiosk-product-card-v6-atom
        [product]="product()"
        [quantity]="quantity()"
        (addProduct)="addProduct.emit()"
        (showProduct)="showProduct.emit()"
        [textColor]="textColor()"
        [cardColor]="cardColor()"
        [isProductAvailable]="effectiveIsProductAvailable()"
        [buttonBackgroundColor]="buttonBackgroundColor()"
        [unavailableButtonBackground]="unavailableButtonBackground()"
        [unavailableButtonText]="unavailableButtonText()"
        [buttonTextColor]="buttonTextColor()"
        [priceColor]="priceColor()"
        [class]="productCardType()"
        [isShowProductIcon]="isShowProductIcon()"
      />
    }
  `,
})
export class KioskProductCardFactoryComponent implements KioskProductCardInputs {
  private readonly kioskGlobalSettingsService = inject(KioskGlobalSettingsService);

  protected readonly productCardChoice = computed(() => {
    return this.kioskGlobalSettingsService.settings().productCard.choice;
  });

  protected readonly productCardType = computed(() => {
    return this.kioskGlobalSettingsService.settings().productCard.styles.type;
  });

  protected readonly cardColSpan = this.kioskGlobalSettingsService.productCardColSpan();

  readonly product = input.required<DoodProductModel>();
  readonly quantity = input.required<number | undefined>();
  readonly isProductAvailable = input<boolean | undefined>(true);
  readonly textColor = input<IContentBuilderFieldColor>();
  readonly cardColor = input<IContentBuilderFieldColor>();
  readonly buttonBackgroundColor = input<IContentBuilderFieldColor>();
  readonly unavailableButtonBackground = input<IContentBuilderFieldColor>();
  readonly unavailableButtonText = input<IContentBuilderFieldColor>();
  readonly buttonTextColor = input<IContentBuilderFieldColor>();
  readonly priceColor = input<IContentBuilderFieldColor | undefined>({
    value: 'neutral-900',
    type: ColorFieldTypesValues.Palette,
  });
  readonly borderColor = input<IContentBuilderFieldColor>();
  readonly isShowProductIcon = input<boolean>(true);

  readonly addProduct = output<void>();
  readonly showProduct = output<void>();

  protected readonly effectiveIsProductAvailable = computed(() => {
    const product = this.product();
    const isStockUnavailable =
      product[ProductKeys.InventoryTracked] === true &&
      (product[ProductKeys.InventoryAvailable] ?? 0) <= 0;

    return (this.isProductAvailable() ?? true) && !isStockUnavailable;
  });
}
